import {
  Fade,
  Card,
  Stack,
  Avatar,
  Checkbox,
  Typography,
  CardHeader,
  CardActions,
} from "@mui/material";

import jMoment from "moment-jalaali";
import ActivateLab from "../ActivateLab";
import ActivateUnit from "../ActivateUnit";
import ActivateDoctor from "../ActivateDoctor";

import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import RecommendRoundedIcon from "@mui/icons-material/RecommendRounded";
import ChangeCircleRoundedIcon from "@mui/icons-material/ChangeCircleRounded";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";
import PendingActionsRoundedIcon from "@mui/icons-material/PendingActionsRounded";
import PlaylistAddCheckCircleRoundedIcon from "@mui/icons-material/PlaylistAddCheckCircleRounded";

const statuses = {
  TODO: {
    icon: <PlaylistAddCheckCircleRoundedIcon color="inherit" />,
    title: "ثبت شده",
    color: "info.main",
  },
  PENDING: {
    icon: <PendingActionsRoundedIcon color="inherit" />,
    title: "در حال بررسی",
    color: "warning.main",
  },
  REJECTED: {
    icon: <ErrorRoundedIcon color="inherit" />,
    title: "رد شده",
    color: "error.main",
  },
  CANCELLED: {
    icon: <RemoveCircleRoundedIcon color="inherit" />,
    title: "لغو شده",
    color: "error.main",
  },
  DOING: {
    icon: <ChangeCircleRoundedIcon color="inherit" />,
    title: "در حال انجام",
    color: "primary.main",
  },
  DONE: {
    icon: <RecommendRoundedIcon color="inherit" />,
    title: "انجام شده",
    color: "success.main",
  },
};

const types = {
  ACTIVATE_LAB: "درخواست فعالسازی لابراتوار",
  ACTIVATE_UNIT: "درخواست فعالسازی کلینیک",
  ACTIVATE_DOCTOR: "درخواست فعالسازی پزشک",

  READY_OWNER: "درخواست مالکیت ناوگان",
  READY_AGREEMENT: "درخواست پیوستن ناوگان",
  READY_CARGO: "درخواست فعالسازی شرکت حمل",
  READY_COMPANY: "درخواست فعالسازی شرکت",
  READY_LICENSE: "اعطای مجوز حمل",
  ACTIVATE_USER: "درخواست فعالسازی کاربر",
  ACTIVATE_DRIVER: "درخواست فعالسازی راننده",
  ACTIVATE_VEHICLE: "درخواست فعالسازی ناوگان",
  ACTIVATE_DRIVER_VEHICLE: "درخواست فعالسازی راننده و ناوگان",
  CREATE_CARGO: "CREATE_CARGO",
  CREATE_COMPANY: "CREATE_COMPANY",
  SET_ROLE: "SET_ROLE",
  TRANSPORT: "TRANSPORT",
  SETTLEMENT: "SETTLEMENT",
  CONTAC: "CONTACT",
};

function getType(type) {
  return types[type] || type;
}

function getStatus(status) {
  return statuses[status] || {};
}

export default function Model({
  model,
  delay,
  checked,
  refetch,
  isAssign,
  handleSelect,
}) {
  const { id, title, media, status, type, request_date, details } = model;
  return (
    <>
      <Fade
        in
        unmountOnExit
        timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}
      >
        <Stack direction="row" alignItems="center" columnGap={0.5}>
          {isAssign && (
            <Checkbox size="small" checked={checked} onChange={handleSelect} />
          )}
          <Stack rowGap={0.5} width={54} alignItems="center">
            <Typography variant="caption">
              {jMoment(request_date).format("hh:mm")}
            </Typography>
            <Typography variant="caption" fontSize={8}>
              {jMoment(request_date).format("dddd")}
            </Typography>
          </Stack>
          <Card
            sx={{
              width: "100%",
              position: "relative",
              bgcolor: checked
                ? "action.disabledBackground"
                : "warning.lighter",
            }}
          >
            <CardHeader
              sx={{ p: 1 }}
              avatar={
                <Avatar
                  sx={{
                    bgcolor: "action.hover",
                    color: getStatus(status)?.color,
                  }}
                >
                  {getStatus(status)?.icon}
                </Avatar>
              }
              title={
                <Typography variant="subtitle1">
                  {getType(model.type)}
                </Typography>
              }
            />
            <CardActions sx={{ justifyContent: "flex-end" }}>
              {/* <CreateShop
                ids={model.id}
                refetch={refetch}
                title={getType(model.type)}
              /> */}
              {/* {model.type === "ACTIVATE_DRIVER_VEHICLE" && (
                <ActivateDriverVehicle
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )} */}
              {/* {model.type === "ACTIVATE_DRIVER" && (
                <ActivateDriver
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )}
              {model.type === "ACTIVATE_VEHICLE" && (
                <ActivateVehicle
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )}
              {model.type === "READY_CARGO" && (
                <ActivateCargo
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )}
              {model.type === "READY_COMPANY" && (
                <ActivateCompany
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )}
              {model.type === "READY_AGREEMENT" && (
                <ReadyAgreement
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )}
              {model.type === "READY_OWNER" && (
                <ReadyOwnership
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )}
              {model.type === "READY_LICENSE" && (
                <ReadyLicense
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )}
              {model.type === "ACTIVATE_USER" && (
                <ActivateUser
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )}
               */}
              {model.type === "ACTIVATE_LAB" && (
                <ActivateLab
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )}
              {model.type === "ACTIVATE_UNIT" && (
                <ActivateUnit
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )}
              {model.type === "ACTIVATE_DOCTOR" && (
                <ActivateDoctor
                  id={model.id}
                  refetch={refetch}
                  title={getType(model.type)}
                />
              )}
            </CardActions>
          </Card>
        </Stack>
      </Fade>
    </>
  );
}
